import { type SVGProps } from 'react'
import { cx } from '#app/utils/cx.ts'

export const SpacebrainsLogoMinimal = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="800"
			height="800"
			viewBox="0 0 800 800"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			className={cx('size-8 shrink-0', props.className)}
		>
			<path
				d="M400.007 0L278.396 75.367L400.007 150.734L521.613 75.367L400.007 0Z"
				fill="#004A8F"
			/>
			<path
				d="M521.607 75.3646V292.08L657.383 207.929C752.464 149.002 799.999 163.791 799.999 252.303V419.312C799.999 507.832 752.464 581.554 657.383 640.481L399.996 799.999V150.732L521.607 75.3646ZM521.607 626.289L650.164 546.61C668.972 534.955 678.38 520.375 678.38 502.883V319.484C678.38 302.001 668.972 299.085 650.164 310.744L521.607 390.419V626.289Z"
				fill="#002952"
			/>
			<path
				d="M400.008 559.849V452.539L155.052 310.923C130.439 298.051 118.128 302.367 118.128 323.863C118.128 346.772 129.066 365.245 150.941 379.295L353.101 525.499C370.192 536.628 386.105 548.305 400.008 559.849V800C376.113 794.855 65.068 590.12 65.068 590.12L0 518.168V454.055L275.615 626.036C300.063 638.815 312.293 634.449 312.293 612.953C312.293 590.891 301.967 573.016 281.34 559.314L138.817 468.966C46.274 408.246 0 342.242 0 270.968C0 180.036 58.6473 165.228 175.933 226.541L400.008 353.822V464.226"
				fill="#003566"
			/>
			<path
				d="M399.996 353.929L465.354 320.631V418.974L399.996 452.5V353.929Z"
				fill="#004A8F"
			/>
			<path
				d="M399.996 559.605C443.154 554.857 464.725 581.364 464.725 639.101C464.725 704.298 443.154 757.848 399.996 799.752V559.605Z"
				fill="#004A8F"
			/>
		</svg>
	)
}
